import { render, staticRenderFns } from "./LaHeader.vue?vue&type=template&id=5a099c97&scoped=true&"
import script from "./LaHeader.vue?vue&type=script&lang=js&"
export * from "./LaHeader.vue?vue&type=script&lang=js&"
import style0 from "./LaHeader.vue?vue&type=style&index=0&id=5a099c97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a099c97",
  null
  
)

export default component.exports